// extracted by mini-css-extract-plugin
export default {"root":"EditListingCategoryPanel_root__kc0Mh"};